import { render, staticRenderFns } from "./LaAdvantage.vue?vue&type=template&id=0118ca56&scoped=true&"
import script from "./LaAdvantage.vue?vue&type=script&lang=js&"
export * from "./LaAdvantage.vue?vue&type=script&lang=js&"
import style0 from "./LaAdvantage.vue?vue&type=style&index=0&id=0118ca56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0118ca56",
  null
  
)

export default component.exports